<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-4">{{ title }}</h4>
      <div id="income-type-chart" class="apex-charts"></div>
      <apexchart
        v-if="series !== null"
        class="apex-charts"
        height="230"
        dir="rtl"
        :series="series"
        :options="{ ...chartOptions, ...{ labels: labels } }"
      ></apexchart>
      <ChartNoDataMessage v-else />
      <div
        v-if="series !== null"
        class="row flex justify-content-center align-items-center flex-wrap"
      >
        <div class="mx-2" :key="i" v-for="(item, i) in series">
          <div class="text-center mt-4">
            <p class="mb-2">
              <i
                class="mdi mdi-circle font-size-10 mr-1"
                :style="{ color: chartOptions.colors[i] }"
              ></i>
              {{ series[i] }}
            </p>
            <h5>
              {{
                item !== 0
                  ? (
                      (item * 100) /
                      $helper.calculateChartSeriesTotal(series)
                    ).toFixed(2)
                  : 0
              }}%
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pieChartOptions from '@/data/pie-chart-options.js'

export default {
  name: 'IncomeChartByType',
  props: {
    applicationId: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: 'انواع درآمد',
    },
    options: {
      type: Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      chartOptions: pieChartOptions,
      series: null,
      labels: null,
    }
  },
  mounted() {
    this.chartOptions = {
      ...this.chartOptions,
      ...{
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value
              Number += ''
              Number = Number.replace(',', '')
              const x = Number.split('.')
              let y = x[0]
              const z = x.length > 1 ? '.' + x[1] : ''
              const rgx = /(\d+)(\d{3})/
              while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
              return y + z + ' تومان'
            },
          },
        },
      },
    }
    if (this.options !== null) {
      this.chartOptions = { ...this.chartOptions, ...this.options }
    }
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let route = `income/group-by-type`
      if (this.applicationId !== null) {
        route += '?application_id=' + this.applicationId
      }
      await this.$axios.get(route).then((res) => {
        this.chartOptions = {
          ...this.chartOptions,
          ...{ labels: res.data.labels },
        }
        this.labels = res.data.labels
        this.series = res.data.data
      })
    },
  },
}
</script>
